import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { StoreState } from "../store";
import { PrintType } from "../../types/products/ProductDTO";


type PrintState = {
  selectedPrintType: PrintType | null;
};

const initialState: PrintState = {
  selectedPrintType: null,
};

const printSlice = createSlice({
  name: "print",
  initialState,
  reducers: {
    setSelectedPrintType(state, action: PayloadAction<PrintType | null>) {
      state.selectedPrintType = action.payload;
    },
  },
});

export const { setSelectedPrintType } = printSlice.actions;

export const useSelectedPrintType = () =>
  useSelector((state: StoreState) => state.printState.selectedPrintType);

export default printSlice.reducer;
